import {
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  SelectChangeEvent,
  useEventCallback,
} from '@mui/material';
import { memo } from 'react';
import { IdentityCardVM } from 'front-office/view-models/reprint-cid/form';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker, DateTimePicker } from '@mui/lab';
import { noop } from 'shell/utils/noop';
import TypeIndentityCard from 'shell/components/shared/type-indentity-card';
import ReleaseModeIndentityCard from 'shell/components/shared/release-mode';
import TypePaymentList from 'front-office/components/shared/payment/type-payment';
// import ListYesNo from 'shell/components/shared/list-yes-no';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import { FormikErrors, FormikTouched } from 'formik';

interface FormProps {
  onChange: (key: keyof IdentityCardVM, value: IdentityCardVM[keyof IdentityCardVM]) => void;
  values?: IdentityCardVM;
  touched?: FormikTouched<IdentityCardVM>;
  errors?: FormikErrors<IdentityCardVM>;
}

const FormComponent = ({ onChange, values, errors, touched }: FormProps): React.ReactElement => {
  const onChangeReleaseMode = useEventCallback((type?: string) => {
    onChange('reasonRelease', type);
  });

  const onChangeTypePayment = useEventCallback((event?: SelectChangeEvent<string>) => {
    onChange('paymentType', event?.target.value);
  });

  return (
    <Grid container spacing={2}>
      {/* <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Carta precedente"
          label="Carta precedente"
          id="oldCard"
          name="oldCard"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.oldCard || ''}
          onChange={(event) => {
            onChange('oldCard', event.target.value);
          }}
          disabled={!values?.isPaper}
        />
      </Grid> */}
      {/* <Grid item xs={12} md={5}>
        <DatePicker
          label="Data scadenza"
          aria-label="Data scadenza"
          value={values?.oldDateExpiration || null}
          onChange={(date) => {
            onChange('oldDateExpiration', date || null);
          }}
          disabled={!values?.isPaper}
          renderInput={(params) => (
            <PmiTextField {...params} id="oldDateExpiration" fullWidth helperText="" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <FormControlLabel
          control={
            <Checkbox
              id="isValidOld"
              checked={values?.isValidOld || false}
              onChange={() => {
                onChange('isValidOld', !values?.isValidOld);
              }}
              inputProps={{ 'aria-label': 'Ancora valida' }}
              disabled={!values?.isPaper}
            />
          }
          label="Ancora valida"
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <FormControlLabel
          control={
            <Checkbox
              id="isReturnedOld"
              checked={values?.isReturnedOld || false}
              onChange={() => {
                onChange('isReturnedOld', !values?.isReturnedOld);
              }}
              inputProps={{ 'aria-label': 'Carta resa' }}
              disabled={!values?.isPaper}
            />
          }
          label="Carta resa"
        />
      </Grid> */}
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Numero"
          label="Numero"
          id="number"
          name="number"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.number || ''}
          onChange={noop}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TypeIndentityCard label="Tipo" value={values?.type || ''} onChange={noop} disabled />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControlLabel
          control={
            <Checkbox
              id="isExpatriationBan"
              checked={values?.isExpatriationBan || false}
              onChange={() => {
                onChange('isExpatriationBan', !values?.isExpatriationBan);
              }}
              inputProps={{ 'aria-label': 'Interdizione espatrio' }}
              disabled
            />
          }
          label="Interdizione espatrio"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data rilascio"
          aria-label="Data rilascio"
          value={values?.dateRelease || null}
          onChange={noop}
          disabled
          renderInput={(params) => (
            <PmiTextField {...params} id="dateRelease" fullWidth helperText="" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data scadenza"
          aria-label="Data scadenza"
          value={values?.dateExpiration || null}
          onChange={noop}
          disabled
          renderInput={(params) => (
            <PmiTextField {...params} id="dateExpiration" fullWidth helperText="" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DateTimePicker
          label="Data e ora contabilizzazione *"
          aria-label="Data e ora contabilizzazione"
          value={values?.dateContabilizzazione || null}
          onChange={(date) => {
            onChange('dateContabilizzazione', date);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateContabilizzazione"
              fullWidth
              helperText={errors?.dateContabilizzazione}
              error={touched?.dateContabilizzazione && Boolean(errors?.dateContabilizzazione)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <ReleaseModeIndentityCard
          value={values?.reasonRelease || ''}
          onChange={onChangeReleaseMode}
          required
          disabled={values?.reasonReleaseFromDB}
          error={touched?.reasonRelease && !!errors?.reasonRelease}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <TypePaymentList
          value={values?.paymentType || ''}
          onChange={onChangeTypePayment}
          withEsente
          required
          error={touched?.paymentType && !!errors?.paymentType}
        />
      </Grid>
      {/* <Grid item xs={12} md={5}>
        <ListYesNo
          label="Stampa genitori"
          value={values?.parentsPrint || ''}
          onChange={noop}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <ListYesNo
          label="Servizio a domicilio"
          value={values?.homeService || ''}
          onChange={noop}
          disabled
        />
      </Grid> */}
      <Grid item xs={12}>
        <PmiTitleDivider>Comune di rilascio</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} md={8}>
        <PmiTextField
          aria-label="Comune"
          label="Comune"
          id="municipality"
          name="municipality"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.municipality || ''}
          onChange={noop}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Provincia"
          label="Provincia"
          id="province"
          name="province"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.province || ''}
          onChange={noop}
          disabled
        />
      </Grid>
      {/* <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Statura"
          label="Statura *"
          id="stature"
          name="stature"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.stature || ''}
          onChange={(event) => {
            onChange('stature', event?.target.value);
          }}
          error={touched?.stature && Boolean(errors?.stature)}
          helperText={errors?.stature}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Capelli"
          label="Capelli *"
          id="hair"
          name="hair"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.hair || ''}
          onChange={(event) => {
            onChange('hair', event?.target.value);
          }}
          error={touched?.hair && Boolean(errors?.hair)}
          helperText={errors?.hair}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Occhi"
          label="Occhi *"
          id="eyes"
          name="eyes"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.eyes || ''}
          onChange={(event) => {
            onChange('eyes', event?.target.value);
          }}
          error={touched?.eyes && Boolean(errors?.eyes)}
          helperText={errors?.eyes}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          aria-label="Segni particolari"
          label="Segni particolari *"
          id="particularSigns"
          name="particularSigns"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.particularSigns || ''}
          onChange={(event) => {
            onChange('particularSigns', event?.target.value);
          }}
          multiline
          rows={3}
          error={touched?.particularSigns && Boolean(errors?.particularSigns)}
          helperText={errors?.particularSigns}
        />
      </Grid> */}
    </Grid>
  );
};

FormComponent.displayName = 'Accordion Identity Card - Form';

const Form = memo(FormComponent);

export default Form;
